class VideoFeaturePlayer extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.video-feature__play');
    if (!this.video) return;

    this.toggle = this.toggle.bind(this);
    if (this.playButton) this.playButton.addEventListener('click', this.toggle);
    // Note: no custom click handler on the video itself. Once `controls` is
    // enabled the browser's native controls own click-to-play/pause; adding our
    // own toggle here would fire alongside it and double-toggle (pause→resume).
    this.video.addEventListener('play', () => this.classList.add('is-playing'));
    this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
  }

  toggle() {
    if (this.video.paused) {
      this.video.setAttribute('controls', '');
      this.video.play();
    } else {
      this.video.pause();
    }
  }
}

if (!customElements.get('video-feature-player')) {
  customElements.define('video-feature-player', VideoFeaturePlayer);
}
